'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';

const posthogConfigured = Boolean(
  process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN && process.env.NEXT_PUBLIC_POSTHOG_HOST,
);

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (posthogConfigured) {
      posthog.captureException(error);
    }
  }, [error]);

  // Replaces the root layout, so app CSS may not be loaded — inline styles only.
  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', background: '#faf7f8', color: '#1f1a1c', padding: 16 }}>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <h1 style={{ fontSize: 22, margin: '0 0 8px' }}>Campus Hub</h1>
          <p style={{ fontSize: 15, lineHeight: 1.5, margin: '0 0 20px', color: '#5c5458' }}>
            Campus Hub is updating or hit a problem. Please refresh in a moment.
          </p>
          <button onClick={() => window.location.reload()}
            style={{ padding: '10px 22px', fontSize: 14, fontWeight: 600, color: '#fff', background: '#d6246e', border: 0, borderRadius: 12, cursor: 'pointer' }}>
            Reload
          </button>
        </div>
      </body>
    </html>
  );
}
